import React      from 'react';
import AppBar     from '@material-ui/core/AppBar';
import Toolbar    from '@material-ui/core/Toolbar';
import {Typography, makeStyles, Link} from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
    },
}));
const Header = () => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <AppBar position="static" color="primary">
                <Toolbar>
                    <Typography variant="h5" className={classes.title}>
                        <Link href="/" color='inherit'>
                            掃除したくなるアプリ
                        </Link>
                    </Typography>
                    {/* NOTE:本当はHeader部分にSignout設置して、ログインされている時だけ出現させようとしたが、諦め */}
                    {/* {isSignedIn ? 
                        <Button color="inherit" onClick={dispatch(signOut())}>logout</Button> :
                        <></>
                    } */}
                </Toolbar>
            </AppBar>
        </div>
    );
}
export default Header;